import { Loader2, Music4 } from "lucide-react";

// Cabeçalho de página enxuto (título + descrição curta + ação contextual) — seção 27
export function PageHeader({ title, description, icon: Icon, action, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap" data-testid={testid}>
      <div className="min-w-0">
        <h1 className="font-head text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          {Icon && <Icon className="h-6 w-6 text-accent shrink-0" />}
          {title}
        </h1>
        {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

// Estado vazio padronizado — seção 32
export function EmptyState({ icon: Icon = Music4, title, description, action, testid }) {
  return (
    <div data-testid={testid} className="bg-surface border border-dashed border-border rounded-lg p-10 text-center flex flex-col items-center gap-3">
      <div className="h-12 w-12 rounded-full bg-surface-hover flex items-center justify-center text-muted-foreground">
        <Icon className="h-6 w-6" />
      </div>
      {title && <div className="font-head font-semibold text-foreground">{title}</div>}
      {description && <p className="text-sm text-muted-foreground max-w-sm">{description}</p>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}

// Loading padronizado — seção 31
export function Loading({ label = "Carregando...", testid = "loading" }) {
  return (
    <div data-testid={testid} className="flex items-center justify-center gap-2 py-16 text-muted-foreground text-sm">
      <Loader2 className="h-5 w-5 animate-spin text-primary" /> {label}
    </div>
  );
}
